import breakpoints from '../../theme/breakpoints'
import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .wrapper {
    padding: 12px;
    order: 0;
  }  

  .container-weather {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: ${theme.colors.brilliance};
    box-sizing: border-box;
    height: 300px;
    justify-content: space-around;
  }
  
  @media only screen and (min-width: ${breakpoints.lg}px) {
    .container-weather {
      width: 316px;
    }
  }
  
  .container-current-conditions {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;    
  }

  .container-weather-location {
    width: 100%;
    margin: 0 0 15px 0;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: ${redesignedTheme.colors.mineShaft};
    text-transform: capitalize;
  }
  
  .container-weather-top {
    padding: 0 0 30px 0;
  }
  
  .row {
    display: flex;
  }

  .temperature {
    font-weight: 600;
    font-size: 35px;
    line-height: 42px;
    color: ${redesignedTheme.colors.mineShaft};
  }
  
  .container-weather-icon {
    width: 50px;
    height: 50px;
    display: flex;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .description {
    font-weight: 500;
  }
  
 .row:not(:last-of-type) {
    padding: 0 0 9px 0;
  }

  .data {
    color: ${theme.colors.codGray};
    font-weight: 500;
  }

  .container-weather :global(.row) :global(span:first-of-type) {
    width: 130px;
  }
`
